import { FC } from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, Button } from "../../../components/ui"
import { AlertTriangle } from "lucide-react"

type UnitDeleteDialogProps = {
  isShowing: boolean
  unitName: string
  unitAbbreviation: string
  onClose: () => void
  onConfirmDelete: () => void
}

export const UnitDeleteDialog: FC<UnitDeleteDialogProps> = ({
  isShowing,
  unitName,
  unitAbbreviation,
  onClose,
  onConfirmDelete
}) => {
  return (
    <Dialog open={isShowing} onOpenChange={onClose}>
      <DialogContent className="dark:bg-neutral800 dark:border-neutral700">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-error600 dark:text-error400">
            <AlertTriangle width={24} height={24} />
            Delete Storage Unit
          </DialogTitle>
        </DialogHeader>

        <div className="py-4">
          <div className="bg-error50 dark:bg-error900/20 border-2 border-error200 dark:border-error800 rounded-lg p-4">
            <p className="text-sm text-error900 dark:text-error200 font-semibold mb-3">
              Are you sure you want to delete this unit?
            </p>
            <div className="bg-white dark:bg-neutral900 rounded-lg p-3 border border-error200 dark:border-error700">
              <p className="font-bold text-neutral900 dark:text-neutral100">{unitName}</p>
              <p className="text-xs text-neutral600 dark:text-neutral400 font-mono">{unitAbbreviation}</p>
            </div>
          </div>

          <div className="mt-4 bg-warning50 dark:bg-warning900/20 border border-warning300 dark:border-warning700 rounded-lg p-3">
            <p className="text-sm text-warning900 dark:text-warning200">
              <strong>Warning:</strong> This will also delete all bins associated with this unit and clear the unit and location references from inventory items. You'll need to reassign affected items to a new unit. This action cannot be undone.
            </p>
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirmDelete}
          >
            Delete Unit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
